import type { ComponentRef, ViewContainerRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import type { Observable } from 'rxjs';
import { map, startWith } from 'rxjs';

import { setInputs } from '@core/common-legacy';
import type { ViewFilterInput, ViewFilterInputDef } from '@core/views-types';

import type { InputComponentContext, InputService } from '../types';
import { InputTextComponent } from './input-text.component';
import type { InputTextFormValue, InputTextSavedValue } from './types';

export class InputTextService implements InputService {
  public savedToFormValue(input: ViewFilterInput<InputTextSavedValue>): InputTextFormValue {
    return { data: input.value.data };
  }

  public getComponentState(input: ViewFilterInput<InputTextSavedValue>) {
    return input.value.data;
  }

  public getInputControl(inputDef: ViewFilterInputDef): InputTextComponent['inputControl'] {
    const validators = Validators.compose([inputDef.required ? Validators.required : null]);
    return new FormGroup({
      data: new FormControl('', { nonNullable: true, validators }),
    });
  }

  public createInputComponent(vcRef: ViewContainerRef, destroy$: Observable<void>) {
    const componentRef = vcRef.createComponent(InputTextComponent);
    return componentRef;
  }

  public updateInputs(
    componentRef: ComponentRef<InputTextComponent>,
    inputs: Partial<Pick<InputTextComponent, 'inputControl' | 'state'>>,
  ) {
    setInputs(componentRef, inputs);
    componentRef.changeDetectorRef.detectChanges();
  }

  public getInputLabel(
    context: InputComponentContext,
    control: InputTextComponent['inputControl'],
    inputState$: Observable<null>,
  ) {
    return control.valueChanges.pipe(
      startWith(control.value),
      map(value => value?.data || ''),
    );
  }
}
